'use strict';
// Load expensive cryptography only for an explicit wallet action. Retain SRI and CSP nonce.
const walletAssetRequests = new Map();
function loadWalletAsset(templateId) {
  if (walletAssetRequests.has(templateId)) return walletAssetRequests.get(templateId);
  const request = new Promise((resolve, reject) => {
    const source = document.getElementById(templateId)?.content.querySelector('script');
    if (!source) { reject(new Error('wallet_request_failed')); return; }
    const script = document.createElement('script');
    script.src = source.src;
    script.integrity = source.integrity;
    script.nonce = source.nonce;
    script.onload = resolve;
    script.onerror = () => {
      walletAssetRequests.delete(templateId);
      script.remove();
      reject(new Error('wallet_request_failed'));
    };
    document.head.appendChild(script);
  });
  walletAssetRequests.set(templateId, request);
  return request;
}
async function withWalletCrypto(button, legacy, action) {
  if (button.disabled) return;
  const epoch = walletEpoch, route = location.pathname + location.hash;
  const label = button.textContent;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.textContent = getText('loading');
  try {
    await Promise.all([
      loadWalletAsset('wallet-bitcoin-loader'),
      legacy ? loadWalletAsset('wallet-legacy-loader') : Promise.resolve(),
    ]);
    if (walletEpoch === epoch && location.pathname + location.hash === route) action();
  } catch (error) {
    showMessage(getText('wallet_request_failed'));
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = button.id === 'open-regular-wallet'
      ? getText(document.querySelector('input[name="email-mode"]:checked')?.value === 'create' ? 'wallet_email_create' : 'open')
      : label;
  }
}
